export default __webpack_public_path__ + "static/media/hush.ff17e219.mp4";